import { Stack, Typography } from '@mui/material';
import type { ComponentType } from 'react';
import type { StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { CALCULATOR_LABELS } from './constants';

export type BankingCalculatorProps = StructuredContentDocument<{
  calculator?: string;
  calculatorRegistry?: Record<string, ComponentType>;
}>;

export function BankingCalculator({
  props: { calculator, calculatorRegistry },
}: BankingCalculatorProps) {
  if (!calculator) return null;
  const label = CALCULATOR_LABELS[calculator];
  if (!label) return null;

  const Calculator = calculatorRegistry?.[calculator];
  if (Calculator) {
    return <Calculator />;
  }

  return (
    <Stack spacing={1} data-testid="banking-calculator">
      <Typography component="p" variant="body" sx={{ margin: 0 }}>
        {label}
      </Typography>
      <Typography component="p" variant="body" sx={{ margin: 0 }}>
        Coming soon.
      </Typography>
    </Stack>
  );
}
